'use client'

import { Container } from './styles'

export { Breadcrumbs } from './Breadcrumbs'
export { Content } from './Content'
export { CoverImage } from './CoverImage'
export { Heading } from './Heading'

const sizes = {
  default: 764,
  wide: 1024,
} as const

export interface PageProps {
  size?: keyof typeof sizes
  children?: React.ReactNode
}

export const Page = ({ size = 'default', children }: PageProps) => (
  <Container maxWidth={sizes[size]}>{children}</Container>
)
